import type { CirclesChart } from '../circlesChart.js';
import type { CirclesVariant } from '../gameTypes.js';
import { PALETTE_PRISM } from '../builtinPulseMaps/palettes.js';
import { assembleImportedCirclesChart } from './importedOsuChart.js';
import audioOnsets from './audio/diamond.onsets.json' with { type: 'json' };
import normalImported from './imported/diamond-normal.circles.json' with { type: 'json' };
import hardImported from './imported/diamond-hard.circles.json' with { type: 'json' };
import extremeImported from './imported/diamond-extreme.circles.json' with { type: 'json' };

export const DIAMOND_CIRCLES_VARIANTS: Record<CirclesVariant, CirclesChart> = assembleImportedCirclesChart({
  baseSlug: 'diamond',
  baseTitle: "The Return",
  description: "NIVIRO's 128 BPM future bass. A million-play ranked osu! set with a clean Normal/Hard/Extreme spread.",
  difficulty: 3,
  palette: PALETTE_PRISM,
  audioSrc: '/audio/circles/diamond.mp3',
  attribution: "\"The Return\" by NIVIRO [NCS Release] - https://ncs.io/TheReturn",
  mapper: "Nuvolina & kiry",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 64, offsetMs: 0, totalBeats: 67 },
    hard: { bpm: 64, offsetMs: 0, totalBeats: 67 },
    extreme: { bpm: 64, offsetMs: 0, totalBeats: 67 },
  },
});
